import marketingInstance from './instance'

const updateCoupon = (id, data) => {
  return marketingInstance.put('/coupons/' + id, data)
}

export default updateCoupon
